import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { beforeAfter } from "@/mocks/criacao-sites";

export default function BeforeAfter() {
  const { before, after, note } = beforeAfter;

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Antes e depois"
          badgeIcon="ri-contrast-2-line"
          badgeTone="secondary"
          title="De uma presença digital básica para uma experiência profissional"
          description="A diferença que um projeto bem estruturado faz na percepção da sua empresa."
        />

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Reveal>
            <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative h-56 w-full overflow-hidden bg-background-100">
                <img
                  src={before.image}
                  alt="Exemplo ilustrativo de site antigo, desorganizado e sem adaptação para celular"
                  title="Antes — presença digital básica"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover object-top grayscale"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-foreground-900/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-background-50">
                  <i className="ri-close-line" aria-hidden="true"></i>
                  {before.label}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {before.title}
                </h3>
                <ul className="mt-4 flex flex-col gap-3">
                  {before.points.map((point) => (
                    <li key={point} className="flex items-start gap-3 text-sm text-foreground-600">
                      <i
                        className="ri-close-circle-line mt-0.5 text-lg text-accent-600"
                        aria-hidden="true"
                      ></i>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>

          <Reveal delay={120}>
            <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-secondary-200 bg-background-50">
              <div className="relative h-56 w-full overflow-hidden bg-background-100">
                <img
                  src={after.image}
                  alt="Exemplo ilustrativo de site moderno, organizado, responsivo e com chamadas para ação"
                  title="Depois — experiência profissional"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-secondary-500 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-background-50">
                  <i className="ri-check-line" aria-hidden="true"></i>
                  {after.label}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {after.title}
                </h3>
                <ul className="mt-4 flex flex-col gap-3">
                  {after.points.map((point) => (
                    <li key={point} className="flex items-start gap-3 text-sm text-foreground-700">
                      <i
                        className="ri-checkbox-circle-line mt-0.5 text-lg text-secondary-600"
                        aria-hidden="true"
                      ></i>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        </div>

        <Reveal>
          <p className="mt-6 flex items-start gap-2 text-center text-xs leading-relaxed text-foreground-500 sm:justify-center sm:text-left">
            <i className="ri-information-line shrink-0 text-base" aria-hidden="true"></i>
            {note}
          </p>
        </Reveal>
      </div>
    </section>
  );
}